// @flow

import TransportationPage from './TransportationPage';
import { connect } from 'react-redux';
import { compose } from 'redux';
import type { State } from 'types/redux';
import type { Props } from './TransportationPage';
import { injectIntl } from 'react-intl';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import { getTransportationOptions } from 'store/reducers/apptOptions/actions';
import {
  setTransportationOption,
  setTransportationInfo,
  sendTransportationOptionsShown,
  sendTransportationOptionsStart,
  sendTransportationOptionsFinish
} from 'store/reducers/appointment/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';

// Selectors
import {
  getTransportOptions,
  isValetAvailable
} from 'store/reducers/apptOptions/selectors';
import {
  getTransportation,
  getTransportationOption
} from 'store/reducers/appointment/selectors';
import { currentPath, previousPath } from 'store/reducers/navigation/selectors';
import { errorLoadingAdvisors } from 'store/reducers/errors/selectors';
import { withRouter } from 'react-router';
import {
  getCTABanner,
  showProgressBar,
  hideBottomCTA
} from 'store/reducers/optimizelyABTest/selectors';

const mapStateToProps = (state: State): $Shape<Props> => ({
  transportations: getTransportOptions(state),
  transportation: getTransportation(state),
  transportationOption: getTransportationOption(state),
  isValetAvailable: isValetAvailable(state),
  currentPath: currentPath(state),
  previousPath: previousPath(state),
  noAdvisorsError: errorLoadingAdvisors(state),
  ctaBanner: getCTABanner(state),
  showProgressBar: showProgressBar(state),
  hideBottomCTA: hideBottomCTA(state)
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    {
      goTo,
      getTransportationOptions,
      setTransportationOption,
      setTransportationInfo,
      gtmUserEvent,
      sendTransportationOptionsShown,
      sendTransportationOptionsStart,
      sendTransportationOptionsFinish
    }
  )
)(TransportationPage);



// WEBPACK FOOTER //
// ./src/components/pages/TransportationPage/TransportationPageContainer.js